import type { ComponentProps } from "react";
import { cn } from "../lib/cn";
import { inputClassName } from "./Input";

export type TextareaProps = ComponentProps<"textarea">;

export function Textarea({ className, ...props }: TextareaProps) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        inputClassName,
        "h-auto min-h-16 py-1.5 leading-5 field-sizing-content",
        className,
      )}
      {...props}
    />
  );
}
